import { ZExtension } from "src/business/extensions/ZExtension";

import {
  ZBoundExtension,
  ZExtensionEventType,
  ZExtensionFormBinding,
  ZObjectExtensionBinding,
  ZObjectExtensionWrite,
} from "./ZExtensionBinding";

export const extensionToBound = (extension: ZExtension): ZBoundExtension => ({
  id: extension.id,
  displayId: extension.displayId,
  name: extension.name,
  description: extension.description,
});

export const apiExtensionsToForm = (
  bindings?: ZObjectExtensionBinding[] | null,
): ZExtensionFormBinding[] =>
  bindings?.map(({ event, extension }) => ({ event, extension })) ?? [];

export const formExtensionsToWrite = (
  bindings: ZExtensionFormBinding[],
): ZObjectExtensionWrite[] =>
  bindings.map(({ event, extension }) => ({
    event,
    extensionId: extension.id,
  }));

export const getBindingsForEvent = (
  bindings: ZExtensionFormBinding[],
  event: ZExtensionEventType,
): ZBoundExtension[] => {
  const item = bindings.find((b) => b.event === event);
  return item ? [item.extension] : [];
};

export const hasBindingForEvent = (
  bindings: ZExtensionFormBinding[],
  event: ZExtensionEventType,
): boolean => bindings.some((b) => b.event === event);

export const setBindingForEvent = (
  bindings: ZExtensionFormBinding[],
  event: ZExtensionEventType,
  extension: ZBoundExtension,
): ZExtensionFormBinding[] => [
  ...bindings.filter((b) => b.event !== event),
  { event, extension },
];

export const removeBindingForEvent = (
  bindings: ZExtensionFormBinding[],
  event: ZExtensionEventType,
): ZExtensionFormBinding[] => bindings.filter((b) => b.event !== event);
